import { useRef, useState, useEffect } from "react";
import Select from "react-select";
import Modal from "react-modal";
import { combos } from "./Utils/DescripcionesPlatos";
import { nanoid } from "nanoid";
import { customStyles, ModalAnimado } from "./Utils/CustomStyles";
import { showSuccess, showError,showInfo } from "./Utils/toastUtils";
import { persistirSeleccion, reemplazarProducto } from "./Utils/persistirSeleccion";
import { useItems } from "../Hooks/useItems";
import { FaHamburger, FaTimes, FaChevronDown } from "react-icons/fa";
import { Plus, Minus, Trash2, Info } from "lucide-react";
import { motion } from "framer-motion";
import PromoCarne from "../img/ImgProducts/classic.webp"


const ingredientes =["Mayonesa","Mostaza","Tomate","Cebolla","BBQ","Pepinillos","Lechuga","Ketchup"]




// Si usás iconos de react-icons o framer-motion, agrégalos aquí:
// import { FaHamburger, FaTimes } from "react-icons/fa";
// import { Minus, Plus } from "lucide-react";
// import { motion } from "framer-motion";

Modal.setAppElement("#root");

const opcionesPlatos = Object.keys(combos).map((item) => ({
  label: item,
  value: item,
}));

const PlatoSelectorBarcos = ({ onSeleccion = () => {}, onInteractuar, editarProductoId = null, onCerrarEdicion, soloModal = false }) => {
  // estados principales (mantengo los nombres que usabas)
  const {
    platosSeleccionados,
    setPlatosSeleccionados,
    aumentarCantidad,
    disminuirCantidad,
    eliminarItem
  } = useItems("pedidoBarco");

  const [modalDescripcionInfo, setModalDescripcionInfo] = useState(null); // { id, nombre }
  const [platoPendiente, setPlatoPendiente] = useState(null);
  
   const [hamburguesaExpandida, setHamburguesaExpandida] = useState(null);
    const [proteinaSeleccion, setProteinaSeleccion] = useState("")
  const [exclusionesAbierto, setExclusionesAbierto] = useState(false);
  const [exclusiones, setExclusiones] = useState([]);

  const [bebidasPorHamburguesa, setBebidasPorHamburguesa] = useState({});


  // estados para UI del modal / selección
  const [bebidaSeleccionada, setBebidaSeleccionada] = useState(null);
  const [ajusteEspacio, setAjusteEspacio] = useState(0);
  // Estado: controla si el accordion está abierto
  const [loading, setLoading] = useState(true);
  const [imgsLoaded, setImgsLoaded] = useState(0);
  
  // Suponiendo que tenemos logo + la imagen principal del plato
  const totalImages = modalDescripcionInfo && combos[modalDescripcionInfo.nombre]?.productoImg ? 1 : 0;

  // preparaciones cuando hay cantidad > 1 (ej: Combo Classic)
  const [preparacionMultiple, setPreparacionMultiple] = useState([]);

  const [mostrarTip, setMostrarTip] = useState(false);

  const nombreRef = useRef(null);
  const descRef = useRef(null);

  useEffect(() => {
    if (modalDescripcionInfo) {
      if (totalImages === 0) {
        setLoading(false);
      } else {
        setLoading(true);
        setImgsLoaded(0);
        const t = setTimeout(() => setLoading(false), 800);
        return () => clearTimeout(t);
      }
    }
  }, [modalDescripcionInfo, totalImages]);

  // --- Persistencia en localStorage (mantengo la clave pedidoBarco) ---
  useEffect(() => {
    onInteractuar?.(true);
  }, [onInteractuar]);

  // Cuando se cargan todas las imágenes, ocultamos el loading
  useEffect(() => {
    if (imgsLoaded >= totalImages && totalImages > 0) {
      setLoading(false);
    }
  }, [imgsLoaded, totalImages]);


  useEffect(() => {
    try {
      localStorage.setItem("pedidoBarco", JSON.stringify(platosSeleccionados));
      onSeleccion(platosSeleccionados);
    } catch (e) {
      console.error("Error guardando platosSeleccionados en localStorage", e);
    }
  }, [platosSeleccionados, onSeleccion]);

  useEffect(() => {
    try {
      const yaMostrado = sessionStorage.getItem("tipModificacionMostrado");
      if (yaMostrado) setMostrarTip(false);
    } catch (e) {
      setMostrarTip(false);
    }
  }, []);

  useEffect(() => {
  if (nombreRef.current && descRef.current) {
    const nombreRect = nombreRef.current.getBoundingClientRect();
    const descRect = descRef.current.getBoundingClientRect();
    const espacio = descRect.top - nombreRect.bottom;

    const ESPACIO_MINIMO = 8; // px que consideras "aceptable"
    if (espacio > ESPACIO_MINIMO) {
      setAjusteEspacio(espacio - ESPACIO_MINIMO);
    } else {
      setAjusteEspacio(0);
    }
  }
}, [modalDescripcionInfo]);

useEffect(() => {
  if (modalDescripcionInfo && totalImages > 0) {
    // 🚀 Safety net for mobile: stop loading faster if something goes wrong
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timeout);
  }
}, [modalDescripcionInfo, totalImages]);

// Función que llamamos en cada <img> cuando termina de cargar
const handleImageLoad = () => {
  setImgsLoaded(prev => prev + 1);
  setLoading(false);
};


const mostrarModalAyuda = () => {
  setMostrarTip(true);
  try {
    sessionStorage.setItem("tipModificacionMostrado", "true");
  } catch (e) {}

  // Ocultarlo automáticamente después de unos segundos (opcional)
  setTimeout(() => setMostrarTip(false), 5000);
};

const abrirEdicion = (plato) => {
  const disponible = combos[plato.nombre]?.disponible;
  if (!disponible) {
    showInfo && showInfo("Este producto no está disponible");
    return;
  }
  const platoInfo = platosSeleccionados.find((p) => p.id === plato.id) || plato;
  setModalDescripcionInfo({ id: platoInfo.id, nombre: platoInfo.nombre });
  setPlatoPendiente(platoInfo);
  setPreparacionMultiple(platoInfo.preparacionesPorUnidad || []);
  setBebidaSeleccionada(platoInfo.bebida || null);
  setProteinaSeleccion(platoInfo.proteina || "Carne");
  setExclusiones(platoInfo.exclusiones || []);
  setBebidasPorHamburguesa(platoInfo.bebidasPorHamburguesa || {});
};

useEffect(() => {
  if (!editarProductoId) return;
  const plato = platosSeleccionados.find((p) => p.id === editarProductoId);
  if (plato) abrirEdicion(plato);
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [editarProductoId]);

  // --- Utilidades ---
  const getCantidadPorCombo = (nombre) => {
    if (!nombre) return 1;
    // prioridad a la definición de combos, si existe
    const c = combos[nombre]?.cantidad;
    if (typeof c === "number") return c;
    // caso especial que mencionaste: "Carne Classic" => 2 unidades
    if (nombre === "Carne Classic") return 2;
    // default 1
    return 1;
  };

  const abrirAccordion = (index) => {
    setHamburguesaExpandida(index);
    const anterior = preparacionMultiple[index];
    if (anterior) {
      setProteinaSeleccion(anterior.proteina || "Carne");
      setExclusiones(anterior.exclusiones || []);
      // If beverages per unit exist:
      if (bebidasPorHamburguesa[index]) {
        // already in state
      }
    } else {
      setProteinaSeleccion("Carne");
      setExclusiones([]);
    }
  };

  const manejarListoHamburguesa = () => {
    if (!proteinaSeleccion) {
      showError("Debes seleccionar Carne o Pollo antes de continuar");
      return;
    }

    if (!bebidasPorHamburguesa?.[hamburguesaExpandida]) {
      showError("Debes seleccionar una bebida antes de continuar");
      return;
    }

    // 🔹 Asegurar que guardamos en el índice correcto del array
    setPreparacionMultiple((prev) => {
      const nuevo = Array.isArray(prev) ? [...prev] : [];
      nuevo[hamburguesaExpandida] = {
        proteina: proteinaSeleccion,
        exclusiones: [...exclusiones],
        bebida: bebidasPorHamburguesa[hamburguesaExpandida],
      };
      return nuevo;
    });

    // 🔹 Reseteo temporal - YA NO reseteamos aquí para que al reabrir no parpadee
    // setProteinaSeleccion(null); 
    // setExclusiones([]);

    setHamburguesaExpandida(null);
  };

  

const toggleExclusion = (ingrediente) => {
  setExclusiones((prev) => {
    const nuevo = prev.includes(ingrediente)
      ? prev.filter((i) => i !== ingrediente)
      : [...prev, ingrediente];

    // 👇 Si estamos editando una hamburguesa de combo, guardarlo al instante
    if (hamburguesaExpandida !== null) {
      setPreparacionMultiple(current => {
        const temp = Array.isArray(current) ? [...current] : [];
        temp[hamburguesaExpandida] = {
          ...(temp[hamburguesaExpandida] || {}),
          exclusiones: nuevo
        };
        return temp;
      });
    }
    return nuevo;
  });
};

  


  // --- Manejo de agregar/actualizar plato ---
  const agregarOActualizarPlato = (platoNombre) => {
    if (!platoNombre) return;

    if (combos[platoNombre]?.disponible !== true) {
      showInfo && showInfo('Este producto no está disponible');
      return;
    }

    // creamos el plato pendiente y abrimos modal
    const nuevoId = nanoid();
    const nuevoPlato = {
      id: nuevoId,
      nombre: platoNombre,
      cantidad: 1,
    };
    setPlatoPendiente(nuevoPlato);
    setModalDescripcionInfo({ id: nuevoId, nombre: platoNombre });

    // Resetear estados del modal para un nuevo plato
    setBebidaSeleccionada(null);
    setProteinaSeleccion("");
    setExclusiones([]);
    setBebidasPorHamburguesa({});
    setExclusionesAbierto(false);

    const qty = getCantidadPorCombo(platoNombre);
    if (qty > 1) {
      setPreparacionMultiple(new Array(qty).fill(null));
    } else {
      setPreparacionMultiple([]);
    }
  };

  
const cerrarModal = () => {
  if (!modalDescripcionInfo) return;

  const nombre = modalDescripcionInfo.nombre;
  const precio = parseFloat(combos[nombre]?.precio || 0);

  const cantidadBebidas = combos[modalDescripcionInfo?.nombre]?.cantidadBebidas || 0;

if (cantidadBebidas > 0) {
  if (!bebidaSeleccionada || bebidaSeleccionada.length < cantidadBebidas) {
    showError(`Debes seleccionar la bebida antes de continuar`);
    return;
  }
}

const cantidadHamburguesas = getCantidadPorCombo(modalDescripcionInfo?.nombre) || 0;
const requierePreparacion = combos[modalDescripcionInfo?.nombre]?.preparacion;

if (requierePreparacion && cantidadHamburguesas > 1) {
  const todasPreparadas = Array.from({ length: cantidadHamburguesas }).every(
    (_, idx) => preparacionMultiple?.[idx] // true si existe valor
  );

  if (!todasPreparadas) {
    showError("Debes seleccionar la preparación de todas las hamburguesas");
    return;
  }
}


 const platoFinal = {
  id: modalDescripcionInfo.id || nanoid(),
  nombre,
  cantidad: platoPendiente?.cantidad || 1,
  precio,
  bebida: bebidaSeleccionada || null, // bebidas generales del combo
  proteina: proteinaSeleccion || "Carne",
  exclusiones: exclusiones || [],
  bebidasPorHamburguesa: bebidasPorHamburguesa || {}, // Persistir esto también
  preparacionesPorUnidad: requierePreparacion 
    ? Array.from({ length: getCantidadPorCombo(nombre) }).map((_, idx) => ({
        proteina: preparacionMultiple[idx]?.proteina || "Carne",
        exclusiones: preparacionMultiple[idx]?.exclusiones || [],
        bebida: preparacionMultiple[idx]?.bebida || (bebidaSeleccionada ? bebidaSeleccionada[idx] : null)
      }))
    : []
};


  const platosGuardados = reemplazarProducto(platosSeleccionados, platoFinal);
  persistirSeleccion("pedidoBarco", platosGuardados, onSeleccion);
  setPlatosSeleccionados(platosGuardados);

  setModalDescripcionInfo(null);
  setPlatoPendiente(null);
  setPreparacionMultiple([]);
  setBebidaSeleccionada(null);
  setProteinaSeleccion("");
  setExclusiones([]);
  setBebidasPorHamburguesa({});
  setExclusionesAbierto(false);

  showSuccess && showSuccess("Combo actualizado");
  onCerrarEdicion?.();
  
  let yaMostrado = false;
  try {
    yaMostrado = sessionStorage.getItem("tipModificacionMostrado");
  } catch (e) {}

  if (!yaMostrado && !soloModal) {
    setTimeout(() => {
      mostrarModalAyuda();
    }, 2000);
  }
};

  const forzarCerrarModal = () => {
    setModalDescripcionInfo(null);
    setPlatoPendiente(null);
    setPreparacionMultiple([]);
    onCerrarEdicion?.();
  };

const precioTotal = () =>
  platosSeleccionados
    .reduce((total, plato) => total + (plato.precio * plato.cantidad), 0)
    .toFixed(2);




  // --- Renderizado principal ---
  return (
    <div className={soloModal ? "" : "max-w-xl mx-auto mb-3"}>
      {!soloModal && (
      <>
      <Select
        options={opcionesPlatos}
        styles={customStyles}
        placeholder="Selecciona un Combo"
        onChange={(opt) => agregarOActualizarPlato(opt.value)}
        menuPlacement="auto"
      />

      <div className="space-y-4 mt-4">
        {platosSeleccionados.map((plato) => (
          <div 
          key={plato.id} 
          className="relative rounded-lg overflow-hidden shadow-md">
            {/* Imagen de fondo */}
                    <div
                      className="absolute inset-0 bg-center bg-contain bg-no-repeat"
              style={{
                backgroundImage: `url(${combos[plato.nombre]?.productoImg})`,
                backgroundSize: "100%",
              }}
                    />
            <div className="absolute inset-0 bg-black/40" />
            <div className="relative p-4 space-y-2 text-white">
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
                <h3 className="font-extrabold text-xl flex items-center justify-between sm:justify-start">
                  {plato.nombre}
           <button
  onClick={() => abrirEdicion(plato)}
>
  <Info size={18} />


</button>
  {mostrarTip && (
  <div
    style={{
      position: "absolute", // relativo a la tarjeta
      top: "70%",           // centrar vertical
      left: "50%",          // centrar horizontal
      transform: "translate(-5%, -60%)", // verdadero centro
      backdropFilter: "blur(10px)",
      WebkitBackdropFilter: "blur(10px)",
      background: "rgba(0, 0, 0, 0.35)",
      color: "#fff",
      padding: "6px 8px",
      borderRadius: "10px",
      fontSize: "10px",
      maxWidth: "160px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
      zIndex: 999999,
      textAlign: "center",
      animation: "fadeIn 0.4s ease",
      pointerEvents: "none",
    }}
  >
    ¡Modifica tu pedido tocando este ícono!

    {/* Flecha apuntando al botón */}
    <div
      style={{
        position: "absolute",
        top: "-8px", // poner justo encima del tip
        right: "10px", // ajustar según la posición del botón info
        width: 0,
        height: 0,
        borderLeft: "8px solid transparent",
        borderRight: "8px solid transparent",
        borderBottom: "8px solid rgba(0,0,0,0.35)", // flecha apuntando arriba
        filter: "blur(0.3px)",
      }}
    />
  </div>
)}

                </h3>

                <div className="flex items-center justify-center space-x-2 mt-2 sm:mt-0">
              <button
                onClick={() => disminuirCantidad(plato.id, showSuccess)}
                className="p-1 hover:text-gray-200"
              >
                <Minus size={18} />
              </button>
              <button
                onClick={() => aumentarCantidad(plato.id, showSuccess)}
                className="p-1 hover:text-gray-200"
              >
                <Plus size={18} />
              </button>
              <button
                onClick={() => eliminarItem(plato.id, showSuccess)}
                className="p-1 text-white hover:text-red-800"
              >
                <Trash2 size={18} />
              </button>
            </div>
              </div>

              <p className="text-sm mt-2 text-center">Cantidad: {plato.cantidad}</p>

             
            </div>
          </div>
        ))}
      </div>
      </>
      )}

      {/* Modal animado (contenido dinámico según el combo seleccionado) */}
      <ModalAnimado isOpen={!!modalDescripcionInfo} onClose={cerrarModal}>
        <div className="relative z-10 flex flex-col h-full">
          {/* Botón cerrar */}
          <button
            onClick={forzarCerrarModal}
            className="absolute top-1 right-1 z-50 bg-yellow-400 hover:bg-white/50 transition rounded-xl w-9 h-9 flex items-center justify-center text-xl text-white/80 font-bold"
          >
            <FaTimes className="text-white text-2xl" />
          </button>

          {/* Contenedor general */}
          <div className="flex-1 flex flex-col relative">
            <div className="flex-1 overflow-hidden relative">
              <motion.div
                key="combo-page"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className="h-full flex flex-col"
              >
                {/* Loader - Estilo original con blur opcional */}
                {loading && (
                  <motion.div
                    key="loader"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    className="absolute inset-0 flex flex-col items-center justify-center z-50 rounded-2xl bg-white/10 backdrop-blur-[2px]"
                  >
                    <div className="w-16 h-16 border-4 border-yellow-500 border-t-transparent rounded-full animate-spin"></div>
                    <p className="text-gray-600 font-bold text-lg mt-4">Preparando combo...</p>
                  </motion.div>
                )}

                <div className={`flex-1 overflow-y-auto px-5 pt-2 pb-4 transition-all duration-500 ${loading ? "blur-sm grayscale-[0.5]" : "blur-0 grayscale-0"}`}>
                  
                  {/* Imagen + nombre */}
                  <div className="relative w-full flex justify-center mb-6 -mt-4">
                    <img
                      src={combos[modalDescripcionInfo?.nombre]?.productoImg}
                      alt={modalDescripcionInfo?.nombre}
                      className="object-contain drop-shadow-xl rounded-lg"
                      style={{
                        maxHeight: `${combos[modalDescripcionInfo?.nombre]?.altoImg || 250}px`,
                        maxWidth: `${combos[modalDescripcionInfo?.nombre]?.anchoImg || 250}px`,
                        marginTop: `-${combos[modalDescripcionInfo?.nombre]?.marginTop || 0}px`
                      }}
                      onLoad={handleImageLoad}
                      onError={() => setLoading(false)}
                      loading="eager"
                    />
                    <div
                      className="absolute -mb-3 w-auto text-center py-1 rounded-r-xl"
                      style={{
                        bottom: `${combos[modalDescripcionInfo?.nombre]?.bottom || 0}px`
                      }}
                    >
                      <h2
                        ref={nombreRef}
                        className="text-2xl sm:text-3xl font-extrabold uppercase text-yellow-400 drop-shadow-lg"
                      >
                        {modalDescripcionInfo?.nombre}
                      </h2>
                    </div>
                  </div>

                  {/* Descripción */}
                  {combos[modalDescripcionInfo?.nombre]?.descripcion && (
                    <p
                      ref={descRef}
                      className="text-base leading-snug tracking-wide text-gray-400 uppercase font-semibold text-center drop-shadow-sm mb-3"
                      style={{
                        marginTop: `-${ajusteEspacio}px`
                      }}
                    >
                      {combos[modalDescripcionInfo?.nombre]?.descripcion}
                    </p>
                  )}

                  {/* Selector proteína */}
                  {combos[modalDescripcionInfo?.nombre]?.polloOCarne && (
                    <div className="flex justify-center mb-6 gap-2 px-1">
                      {["Carne", "Pollo"].map((opcion) => (
                        <button
                          key={opcion}
                          onClick={() => setProteinaSeleccion(opcion)}
                          className={`px-4 py-2 rounded-full font-extrabold text-sm transition-all ${
                            proteinaSeleccion === opcion
                              ? "bg-gradient-to-r from-[#ff0000] via-[#ff9500] to-[#ffd500] text-white shadow-[0_2px_10px_rgba(255,180,0,0.4)] scale-105"
                              : "bg-transparent text-white/80 hover:text-white hover:bg-white/10"
                          }`}
                        >
                          {opcion}
                        </button>
                      ))}
                    </div>
                  )}

                  {/* Preparaciones múltiples (ej. hamburguesas) - UI ORIGINAL */}
                  {combos[modalDescripcionInfo?.nombre]?.preparacion &&
                    getCantidadPorCombo(modalDescripcionInfo?.nombre) > 1 && (
                      <div className="flex flex-col items-center gap-8 mb-8">
                        <div className="w-full">
                          <div className="relative grid grid-cols-2 sm:grid-cols-2 gap-4 w-full h-[250px]">
                            {Array.from({
                              length: getCantidadPorCombo(modalDescripcionInfo?.nombre),
                            }).map((_, index) => {
                              const isExpanded = hamburguesaExpandida === index;

                              return (
                                <motion.div
                                  key={index}
                                  layout
                                  onClick={() => !isExpanded && abrirAccordion(index)}
                                  className={`rounded-2xl shadow-lg cursor-pointer transition-all duration-300 border
                                    ${
                                      isExpanded
                                        ? "absolute top-0 left-0 w-full h-full z-50 bg-white backdrop-blur-lg"
                                        : "relative w-full h-full flex items-center justify-center bg-white/50"
                                    }
                                  `}
                                  style={isExpanded ? {
                                    backgroundImage: `url(${PromoCarne})`,
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",
                                  } : {}}
                                >
                                  {!isExpanded && (
                                    <FaHamburger
                                      className={`mb-2 transition-all duration-300 ${
                                        preparacionMultiple?.[index]
                                          ? "text-yellow-400 scale-110"
                                          : "text-gray-600"
                                      }`}
                                      size={32}
                                    />
                                  )}

                                  {isExpanded && (
                                    <div className="flex flex-col gap-4 p-6 bg-black/40 rounded-2xl w-full h-full overflow-y-auto">
                                      <div className="flex-1 max-w-auto bg-black/30 backdrop-blur-xl rounded-full p-1 flex shadow-[0_2px_10px_rgba(0,0,0,0.5)] border border-white/10">
                                        {["Carne", "Pollo"].map((opcion) => (
                                          <button
                                            key={opcion}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              setProteinaSeleccion(opcion);
                                              // 👇 GUARDAR AL INSTANTE para que no se pierda al cerrar modal
                                              setPreparacionMultiple(prev => {
                                                const nuevo = Array.isArray(prev) ? [...prev] : [];
                                                nuevo[index] = {
                                                  ...(nuevo[index] || {}),
                                                  proteina: opcion
                                                };
                                                return nuevo;
                                              });
                                            }}
                                            className={`flex-1 px-2 py-1 rounded-full font-extrabold text-sm sm:text-base transition-all
                                              ${
                                                proteinaSeleccion === opcion
                                                  ? "bg-gradient-to-r from-[#ff0000] via-[#ff9500] to-[#ffd500] text-white shadow-[0_2px_10px_rgba(255,180,0,0.4)] scale-105"
                                                  : "bg-transparent text-white/80 hover:text-white hover:bg-white/10"
                                              }
                                            `}
                                          >
                                            {opcion}
                                          </button>
                                        ))}
                                      </div>

                                      <div className="w-full mt-4 mb-3 bg-black/50 rounded-xl shadow-sm pb-2">
                                        <div
                                          className="flex justify-between text-white items-center py-2 px-2 cursor-pointer active:scale-[0.98] transition-all"
                                          onClick={() => setExclusionesAbierto(!exclusionesAbierto)}
                                        >
                                          <p className="font-bold">¿Deseas excluir algo de tu plato?</p>
                                          <FaChevronDown className={`mt-5 text-xl transition-transform duration-300 ${exclusionesAbierto ? "rotate-180" : ""}`} />
                                        </div>

                                        {exclusionesAbierto && (
                                          <div className="mt-3 px-4 pb-1 flex flex-col gap-3">
                                            {ingredientes.map((ing, i) => (
                                              <label key={i} className="flex items-center gap-3 cursor-pointer select-none" onClick={(e) => e.stopPropagation()}>
                                                <div
                                                  onClick={() => toggleExclusion(ing)}
                                                  className={`w-6 h-6 flex items-center justify-center rounded-md border transition-all ${
                                                    exclusiones.includes(ing) ? "bg-neutral-500" : "border-gray-300 bg-white"
                                                  }`}
                                                >
                                                  {exclusiones.includes(ing) && (
                                                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
                                                      <path d="M5 13l4 4L19 7" />
                                                    </svg>
                                                  )}
                                                </div>
                                                <span className="text-white font-bold text-base">Sin {ing}</span>
                                              </label>
                                            ))}
                                          </div>
                                        )}
                                      </div>

                                      {combos[modalDescripcionInfo?.nombre]?.cantidadBebidasPorUnidad > 0 && (
                                        <div className="w-full mt-4">
                                          <h3 className="text-center uppercase text-yellow-500 font-bold tracking-widest text-base mb-3">Elige tu Bebida</h3>
                                          <div className="flex flex-wrap justify-center gap-3">
                                            {combos[modalDescripcionInfo?.nombre]?.bebida?.map((b, idxB) => (
                                              <button
                                                key={idxB}
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  setBebidasPorHamburguesa((prev) => {
                                                    const nuevoB = { ...prev, [index]: b };
                                                    // 👇 GUARDAR AL INSTANTE en preparacionesPorUnidad
                                                    setPreparacionMultiple(curr => {
                                                      const temp = Array.isArray(curr) ? [...curr] : [];
                                                      temp[index] = {
                                                        ...(temp[index] || {}),
                                                        bebida: b
                                                      };
                                                      return temp;
                                                    });
                                                    return nuevoB;
                                                  });
                                                }}
                                                className={`px-5 py-2 rounded-full font-medium text-sm transition-all duration-300 border-2 ${
                                                  bebidasPorHamburguesa?.[index] === b
                                                    ? "bg-yellow-400 text-white border-yellow-400 shadow-lg scale-105"
                                                    : "bg-white/80 text-gray-700 border-gray-200 hover:bg-yellow-50 hover:border-yellow-300"
                                                }`}
                                              >
                                                {b}
                                              </button>
                                            ))}
                                          </div>
                                        </div>
                                      )}

                                      <div className="w-full flex justify-end mt-2">
                                        <button
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            manejarListoHamburguesa();
                                          }}
                                          className="w-20 py-2 bg-yellow-400 text-white font-bold rounded-xl"
                                        >
                                          Listo
                                        </button>
                                      </div>
                                    </div>
                                  )}
                                </motion.div>
                              );
                            })}
                          </div>
                          <p className="text-base text-gray-400 text-center mt-3">Toca cada hamburguesa para definir su preparación</p>
                        </div>
                      </div>
                    )}

                  {/* Selección de bebidas generales */}
                  {(combos[modalDescripcionInfo?.nombre]?.cantidadBebidas ?? 0) > 0 && (
                    <div className="-mb-3 mt-4">
                      <h3 className="text-center uppercase text-gray-500 font-bold mb-4 tracking-widest text-lg">
                        {combos[modalDescripcionInfo?.nombre]?.cantidadBebidas > 1
                          ? `Elige ${combos[modalDescripcionInfo?.nombre]?.cantidadBebidas} bebidas`
                          : "Elige tu bebida"}
                      </h3>
                      <div className="flex flex-wrap justify-center gap-4">
                        {Array.from({
                          length: combos[modalDescripcionInfo?.nombre]?.cantidadBebidas || 1,
                        }).map((_, i) => (
                          <div key={i} className="flex flex-col items-center space-y-2">
                            <span className="text-xs text-gray-400 font-semibold">Bebida #{i + 1}</span>
                            <div className="flex flex-wrap justify-center gap-3">
                              {combos[modalDescripcionInfo?.nombre]?.bebida?.map((b, idx) => (
                                <button
                                  key={idx}
                                  onClick={() =>
                                    setBebidaSeleccionada((prev) => {
                                      const nuevo = [...(prev || [])];
                                      nuevo[i] = b;
                                      return nuevo;
                                    })
                                  }
                                  className={`px-5 py-2 rounded-full font-medium text-sm transition-all duration-300 border-2 ${
                                    bebidaSeleccionada?.[i] === b
                                      ? "bg-yellow-400 text-black border-yellow-400 shadow-lg scale-105"
                                      : "bg-white text-gray-600 border-gray-200 hover:bg-yellow-50 hover:border-yellow-300"
                                  }`}
                                >
                                  {b}
                                </button>
                              ))}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </motion.div>
            </div>

            {/* Footer original */}
            <div className="w-full flex justify-between items-center py-4 border-t-2 border-gray-300 mt-3 px-5">
              <span className="text-2xl font-extrabold text-yellow-400 drop-shadow-md">
                ${platoPendiente
                  ? (platoPendiente.cantidad * (combos[platoPendiente.nombre]?.precio || 0)).toFixed(2)
                  : precioTotal()}
              </span>
              <button
                onClick={cerrarModal}
                className="px-6 py-2 bg-yellow-500 shadow-xl text-lg text-white font-extrabold rounded-xl"
              >
                {soloModal ? "Guardar" : "Agregar"}
              </button>
            </div>
          </div>
        </div>
      </ModalAnimado>
    </div>
  );
};

export default PlatoSelectorBarcos;
